// extracted by mini-css-extract-plugin
module.exports = {"Container":"Subtitle_Container__2VxON"};